import React from 'react';
import cx from 'classnames';
import { SafeHTML } from 'edrolo/domains/app';
import styles from './styles.scss';
/* eslint-disable react/prop-types */ // TODO: add props

const TableRenderer = ({
  content,
  renderResponseField = (responseFieldIndex, isHeading, cellData) => (
    <TableRenderer.Cell isHeading={isHeading}>{cellData}</TableRenderer.Cell>
  ),
  withHeadings,
  instructional,
}) => {
  // we want this to start from 0 every render, it becomes an index in order of respondable cells.
  let responseFieldIndex = 0;
  return (
    <table
      className={cx(styles.tableRenderer, {
        [styles.instructional]: instructional,
      })}
    >
      {withHeadings && content[0] && (
        <thead>
          <tr style={{ height: '1px' }}>
            {content[0].map((cellData, index) => (
              <React.Fragment key={index}>
                {cellData === '' ? (
                  renderResponseField(
                    responseFieldIndex++,
                    !!'isHeading',
                    cellData
                  )
                ) : (
                  <TableRenderer.Cell isHeading>{cellData}</TableRenderer.Cell>
                )}
              </React.Fragment>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {content.slice(withHeadings ? 1 : 0).map((row, rowIndex) => (
          <tr key={rowIndex} style={{ height: '1px' }}>
            {row.map((cellData, index) => (
              <React.Fragment key={index}>
                {cellData === '' ? (
                  renderResponseField(
                    responseFieldIndex++,
                    !'isHeading',
                    cellData
                  )
                ) : (
                  <TableRenderer.Cell>{cellData}</TableRenderer.Cell>
                )}
              </React.Fragment>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

TableRenderer.Cell = ({ children, isHeading, isResponse, className }) => {
  return (
    <SafeHTML
      as={isHeading ? 'th' : 'td'}
      style={{ height: 'inherit' }}
      className={className}
      data-response-cell={isResponse}
    >
      {children}
    </SafeHTML>
  );
};

export default TableRenderer;
